import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { NewsTeasersBlock } from '../../blocksState'
import { NewsTeasersBlockLayout } from './newsTeasersBlockLayout'
import { NewsTeasersBlockState } from './newsTeasersBlockState'
import { NewsTeaserResult } from '../../../../../backendApi/generated'

export const newsTeasersBlockWidget = (block: NewsTeasersBlock): Widget<Updater<NewsTeasersBlockState>> =>
  async<NewsTeaserResult[]>(block.newsTeasersBlockState, newsTeasers =>
    fromJSX(() => (
      <NewsTeasersBlockLayout
        index={block.index}
        inview={block.inview}
        title={block.title}
        newsTeasers={newsTeasers}
      />
    ))
  )
